import { render } from "./Flashback.vue?vue&type=template&id=476fc040&scoped=true"
import script from "./Flashback.vue?vue&type=script&lang=js"
export * from "./Flashback.vue?vue&type=script&lang=js"

import "./Flashback.vue?vue&type=style&index=0&id=476fc040&scoped=true&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476fc040"]])

export default __exports__